export const COUNTRIES = [
  {
    name: 'Afganistán',
    iso3: 'AFG',
  },
  {
    name: 'Albania',
    iso3: 'ALB',
  },
  {
    name: 'Alemania',
    iso3: 'DEU',
  },
  {
    name: 'Algeria',
    iso3: 'DZA',
  },
  {
    name: 'Andorra',
    iso3: 'AND',
  },
  {
    name: 'Angola',
    iso3: 'AGO',
  },
  {
    name: 'Anguila',
    iso3: 'AIA',
  },
  {
    name: 'Antártida',
    iso3: 'ATA',
  },
  {
    name: 'Antigua y Barbuda',
    iso3: 'ATG',
  },
  {
    name: 'Antillas Neerlandesas',
    iso3: 'ANT',
  },
  {
    name: 'Arabia Saudita',
    iso3: 'SAU',
  },
  {
    name: 'Argentina',
    iso3: 'ARG',
  },
  {
    name: 'Armenia',
    iso3: 'ARM',
  },
  {
    name: 'Aruba',
    iso3: 'ABW',
  },
  {
    name: 'Australia',
    iso3: 'AUS',
  },
  {
    name: 'Austria',
    iso3: 'AUT',
  },
  {
    name: 'Azerbayán',
    iso3: 'AZE',
  },
  {
    name: 'Bélgica',
    iso3: 'BEL',
  },
  {
    name: 'Bahamas',
    iso3: 'BHS',
  },
  {
    name: 'Bahrein',
    iso3: 'BHR',
  },
  {
    name: 'Bangladesh',
    iso3: 'BGD',
  },
  {
    name: 'Barbados',
    iso3: 'BRB',
  },
  {
    name: 'Belice',
    iso3: 'BLZ',
  },
  {
    name: 'Benín',
    iso3: 'BEN',
  },
  {
    name: 'Bhután',
    iso3: 'BTN',
  },
  {
    name: 'Bielorrusia',
    iso3: 'BLR',
  },
  {
    name: 'Birmania',
    iso3: 'MMR',
  },
  {
    name: 'Bolivia',
    iso3: 'BOL',
  },
  {
    name: 'Bosnia y Herzegovina',
    iso3: 'BIH',
  },
  {
    name: 'Botsuana',
    iso3: 'BWA',
  },
  {
    name: 'Brasil',
    iso3: 'BRA',
  },
  {
    name: 'Brunéi',
    iso3: 'BRN',
  },
  {
    name: 'Bulgaria',
    iso3: 'BGR',
  },
  {
    name: 'Burkina Faso',
    iso3: 'BFA',
  },
  {
    name: 'Burundi',
    iso3: 'BDI',
  },
  {
    name: 'Cabo Verde',
    iso3: 'CPV',
  },
  {
    name: 'Camboya',
    iso3: 'KHM',
  },
  {
    name: 'Camerún',
    iso3: 'CMR',
  },
  {
    name: 'Canadá',
    iso3: 'CAN',
  },
  {
    name: 'Chad',
    iso3: 'TCD',
  },
  {
    name: 'Chile',
    iso3: 'CHL',
  },
  {
    name: 'China',
    iso3: 'CHN',
  },
  {
    name: 'Chipre',
    iso3: 'CYP',
  },
  {
    name: 'Ciudad del Vaticano',
    iso3: 'VAT',
  },
  {
    name: 'Colombia',
    iso3: 'COL',
  },
  {
    name: 'Comoras',
    iso3: 'COM',
  },
  {
    name: 'Congo',
    iso3: 'COG',
  },
  {
    name: 'Congo',
    iso3: 'COD',
  },
  {
    name: 'Corea del Norte',
    iso3: 'PRK',
  },
  {
    name: 'Corea del Sur',
    iso3: 'KOR',
  },
  {
    name: 'Costa de Marfil',
    iso3: 'CIV',
  },
  {
    name: 'Costa Rica',
    iso3: 'CRI',
  },
  {
    name: 'Croacia',
    iso3: 'HRV',
  },
  {
    name: 'Cuba',
    iso3: 'CUB',
  },
  {
    name: 'Dinamarca',
    iso3: 'DNK',
  },
  {
    name: 'Dominica',
    iso3: 'DMA',
  },
  {
    name: 'Ecuador',
    iso3: 'ECU',
  },
  {
    name: 'Egipto',
    iso3: 'EGY',
  },
  {
    name: 'El Salvador',
    iso3: 'SLV',
  },
  {
    name: 'Emiratos Árabes Unidos',
    iso3: 'ARE',
  },
  {
    name: 'Eritrea',
    iso3: 'ERI',
  },
  {
    name: 'Eslovaquia',
    iso3: 'SVK',
  },
  {
    name: 'Eslovenia',
    iso3: 'SVN',
  },
  {
    name: 'España',
    iso3: 'ESP',
  },
  {
    name: 'Estados Unidos de América',
    iso3: 'USA',
  },
  {
    name: 'Estonia',
    iso3: 'EST',
  },
  {
    name: 'Etiopía',
    iso3: 'ETH',
  },
  {
    name: 'Filipinas',
    iso3: 'PHL',
  },
  {
    name: 'Finlandia',
    iso3: 'FIN',
  },
  {
    name: 'Fiyi',
    iso3: 'FJI',
  },
  {
    name: 'Francia',
    iso3: 'FRA',
  },
  {
    name: 'Gabón',
    iso3: 'GAB',
  },
  {
    name: 'Gambia',
    iso3: 'GMB',
  },
  {
    name: 'Georgia',
    iso3: 'GEO',
  },
  {
    name: 'Ghana',
    iso3: 'GHA',
  },
  {
    name: 'Gibraltar',
    iso3: 'GIB',
  },
  {
    name: 'Granada',
    iso3: 'GRD',
  },
  {
    name: 'Grecia',
    iso3: 'GRC',
  },
  {
    name: 'Groenlandia',
    iso3: 'GRL',
  },
  {
    name: 'Guadalupe',
    iso3: 'GLP',
  },
  {
    name: 'Guam',
    iso3: 'GUM',
  },
  {
    name: 'Guatemala',
    iso3: 'GTM',
  },
  {
    name: 'Guayana Francesa',
    iso3: 'GUF',
  },
  {
    name: 'Guernsey',
    iso3: 'GGY',
  },
  {
    name: 'Guinea',
    iso3: 'GIN',
  },
  {
    name: 'Guinea Ecuatorial',
    iso3: 'GNQ',
  },
  {
    name: 'Guinea-Bissau',
    iso3: 'GNB',
  },
  {
    name: 'Guyana',
    iso3: 'GUY',
  },
  {
    name: 'Haití',
    iso3: 'HTI',
  },
  {
    name: 'Honduras',
    iso3: 'HND',
  },
  {
    name: 'Hong kong',
    iso3: 'HKG',
  },
  {
    name: 'Hungría',
    iso3: 'HUN',
  },
  {
    name: 'India',
    iso3: 'IND',
  },
  {
    name: 'Indonesia',
    iso3: 'IDN',
  },
  {
    name: 'Irán',
    iso3: 'IRN',
  },
  {
    name: 'Irak',
    iso3: 'IRQ',
  },
  {
    name: 'Irlanda',
    iso3: 'IRL',
  },
  {
    name: 'Isla Bouvet',
    iso3: 'BVT',
  },
  {
    name: 'Isla de Man',
    iso3: 'IMN',
  },
  {
    name: 'Isla de Navidad',
    iso3: 'CXR',
  },
  {
    name: 'Isla Norfolk',
    iso3: 'NFK',
  },
  {
    name: 'Islandia',
    iso3: 'ISL',
  },
  {
    name: 'Islas Bermudas',
    iso3: 'BMU',
  },
  {
    name: 'Islas Caimán',
    iso3: 'CYM',
  },
  {
    name: 'Islas Cocos (Keeling)',
    iso3: 'CCK',
  },
  {
    name: 'Islas Cook',
    iso3: 'COK',
  },
  {
    name: 'Islas de Åland',
    iso3: 'ALA',
  },
  {
    name: 'Islas Feroe',
    iso3: 'FRO',
  },
  {
    name: 'Islas Georgias del Sur y Sandwich del Sur',
    iso3: 'SGS',
  },
  {
    name: 'Islas Heard y McDonald',
    iso3: 'HMD',
  },
  {
    name: 'Islas Maldivas',
    iso3: 'MDV',
  },
  {
    name: 'Islas Malvinas',
    iso3: 'FLK',
  },
  {
    name: 'Islas Marianas del Norte',
    iso3: 'MNP',
  },
  {
    name: 'Islas Marshall',
    iso3: 'MHL',
  },
  {
    name: 'Islas Pitcairn',
    iso3: 'PCN',
  },
  {
    name: 'Islas Salomón',
    iso3: 'SLB',
  },
  {
    name: 'Islas Turcas y Caicos',
    iso3: 'TCA',
  },
  {
    name: 'Islas Ultramarinas Menores de Estados Unidos',
    iso3: 'UMI',
  },
  {
    name: 'Islas Vírgenes Británicas',
    iso3: 'VG',
  },
  {
    name: 'Islas Vírgenes de los Estados Unidos',
    iso3: 'VIR',
  },
  {
    name: 'Israel',
    iso3: 'ISR',
  },
  {
    name: 'Italia',
    iso3: 'ITA',
  },
  {
    name: 'Jamaica',
    iso3: 'JAM',
  },
  {
    name: 'Japón',
    iso3: 'JPN',
  },
  {
    name: 'Jersey',
    iso3: 'JEY',
  },
  {
    name: 'Jordania',
    iso3: 'JOR',
  },
  {
    name: 'Kazajistán',
    iso3: 'KAZ',
  },
  {
    name: 'Kenia',
    iso3: 'KEN',
  },
  {
    name: 'Kirgizstán',
    iso3: 'KGZ',
  },
  {
    name: 'Kiribati',
    iso3: 'KIR',
  },
  {
    name: 'Kuwait',
    iso3: 'KWT',
  },
  {
    name: 'Líbano',
    iso3: 'LBN',
  },
  {
    name: 'Laos',
    iso3: 'LAO',
  },
  {
    name: 'Lesoto',
    iso3: 'LSO',
  },
  {
    name: 'Letonia',
    iso3: 'LVA',
  },
  {
    name: 'Liberia',
    iso3: 'LBR',
  },
  {
    name: 'Libia',
    iso3: 'LBY',
  },
  {
    name: 'Liechtenstein',
    iso3: 'LIE',
  },
  {
    name: 'Lituania',
    iso3: 'LTU',
  },
  {
    name: 'Luxemburgo',
    iso3: 'LUX',
  },
  {
    name: 'México',
    iso3: 'MEX',
  },
  {
    name: 'Mónaco',
    iso3: 'MCO',
  },
  {
    name: 'Macao',
    iso3: 'MAC',
  },
  {
    name: 'Macedônia',
    iso3: 'MKD',
  },
  {
    name: 'Madagascar',
    iso3: 'MDG',
  },
  {
    name: 'Malasia',
    iso3: 'MYS',
  },
  {
    name: 'Malawi',
    iso3: 'MWI',
  },
  {
    name: 'Mali',
    iso3: 'MLI',
  },
  {
    name: 'Malta',
    iso3: 'MLT',
  },
  {
    name: 'Marruecos',
    iso3: 'MAR',
  },
  {
    name: 'Martinica',
    iso3: 'MTQ',
  },
  {
    name: 'Mauricio',
    iso3: 'MUS',
  },
  {
    name: 'Mauritania',
    iso3: 'MRT',
  },
  {
    name: 'Mayotte',
    iso3: 'MYT',
  },
  {
    name: 'Micronesia',
    iso3: 'FSM',
  },
  {
    name: 'Moldavia',
    iso3: 'MDA',
  },
  {
    name: 'Mongolia',
    iso3: 'MNG',
  },
  {
    name: 'Montenegro',
    iso3: 'MNE',
  },
  {
    name: 'Montserrat',
    iso3: 'MSR',
  },
  {
    name: 'Mozambique',
    iso3: 'MOZ',
  },
  {
    name: 'Namibia',
    iso3: 'NAM',
  },
  {
    name: 'Nauru',
    iso3: 'NRU',
  },
  {
    name: 'Nepal',
    iso3: 'NPL',
  },
  {
    name: 'Nicaragua',
    iso3: 'NIC',
  },
  {
    name: 'Niger',
    iso3: 'NER',
  },
  {
    name: 'Nigeria',
    iso3: 'NGA',
  },
  {
    name: 'Niue',
    iso3: 'NIU',
  },
  {
    name: 'Noruega',
    iso3: 'NOR',
  },
  {
    name: 'Nueva Caledonia',
    iso3: 'NCL',
  },
  {
    name: 'Nueva Zelanda',
    iso3: 'NZL',
  },
  {
    name: 'Omán',
    iso3: 'OMN',
  },
  {
    name: 'Países Bajos',
    iso3: 'NLD',
  },
  {
    name: 'Pakistán',
    iso3: 'PAK',
  },
  {
    name: 'Palau',
    iso3: 'PLW',
  },
  {
    name: 'Palestina',
    iso3: 'PSE',
  },
  {
    name: 'Panamá',
    iso3: 'PAN',
  },
  {
    name: 'Papúa Nueva Guinea',
    iso3: 'PNG',
  },
  {
    name: 'Paraguay',
    iso3: 'PRY',
  },
  {
    name: 'Perú',
    iso3: 'PER',
  },
  {
    name: 'Polinesia Francesa',
    iso3: 'PYF',
  },
  {
    name: 'Polonia',
    iso3: 'POL',
  },
  {
    name: 'Portugal',
    iso3: 'PRT',
  },
  {
    name: 'Puerto Rico',
    iso3: 'PRI',
  },
  {
    name: 'Qatar',
    iso3: 'QAT',
  },
  {
    name: 'Reino Unido',
    iso3: 'GBR',
  },
  {
    name: 'República Centroafricana',
    iso3: 'CAF',
  },
  {
    name: 'República Checa',
    iso3: 'CZE',
  },
  {
    name: 'República Dominicana',
    iso3: 'DOM',
  },
  {
    name: 'Reunión',
    iso3: 'REU',
  },
  {
    name: 'Ruanda',
    iso3: 'RWA',
  },
  {
    name: 'Rumanía',
    iso3: 'ROU',
  },
  {
    name: 'Rusia',
    iso3: 'RUS',
  },
  {
    name: 'Sahara Occidental',
    iso3: 'ESH',
  },
  {
    name: 'Samoa',
    iso3: 'WSM',
  },
  {
    name: 'Samoa Americana',
    iso3: 'ASM',
  },
  {
    name: 'San Bartolomé',
    iso3: 'BLM',
  },
  {
    name: 'San Cristóbal y Nieves',
    iso3: 'KNA',
  },
  {
    name: 'San Marino',
    iso3: 'SMR',
  },
  {
    name: 'San Martín (Francia)',
    iso3: 'MAF',
  },
  {
    name: 'San Pedro y Miquelón',
    iso3: 'SPM',
  },
  {
    name: 'San Vicente y las Granadinas',
    iso3: 'VCT',
  },
  {
    name: 'Santa Elena',
    iso3: 'SHN',
  },
  {
    name: 'Santa Lucía',
    iso3: 'LCA',
  },
  {
    name: 'Santo Tomé y Príncipe',
    iso3: 'STP',
  },
  {
    name: 'Senegal',
    iso3: 'SEN',
  },
  {
    name: 'Serbia',
    iso3: 'SRB',
  },
  {
    name: 'Seychelles',
    iso3: 'SYC',
  },
  {
    name: 'Sierra Leona',
    iso3: 'SLE',
  },
  {
    name: 'Singapur',
    iso3: 'SGP',
  },
  {
    name: 'Siria',
    iso3: 'SYR',
  },
  {
    name: 'Somalia',
    iso3: 'SOM',
  },
  {
    name: 'Sri lanka',
    iso3: 'LKA',
  },
  {
    name: 'Sudáfrica',
    iso3: 'ZAF',
  },
  {
    name: 'Sudán',
    iso3: 'SDN',
  },
  {
    name: 'Suecia',
    iso3: 'SWE',
  },
  {
    name: 'Suiza',
    iso3: 'CHE',
  },
  {
    name: 'Surinám',
    iso3: 'SUR',
  },
  {
    name: 'Svalbard y Jan Mayen',
    iso3: 'SJM',
  },
  {
    name: 'Swazilandia',
    iso3: 'SWZ',
  },
  {
    name: 'Tadjikistán',
    iso3: 'TJK',
  },
  {
    name: 'Tailandia',
    iso3: 'THA',
  },
  {
    name: 'Taiwán',
    iso3: 'TWN',
  },
  {
    name: 'Tanzania',
    iso3: 'TZA',
  },
  {
    name: 'Territorio Británico del Océano Índico',
    iso3: 'IOT',
  },
  {
    name: 'Territorios Australes y Antárticas Franceses',
    iso3: 'ATF',
  },
  {
    name: 'Timor Oriental',
    iso3: 'TLS',
  },
  {
    name: 'Togo',
    iso3: 'TGO',
  },
  {
    name: 'Tokelau',
    iso3: 'TKL',
  },
  {
    name: 'Tonga',
    iso3: 'TON',
  },
  {
    name: 'Trinidad y Tobago',
    iso3: 'TTO',
  },
  {
    name: 'Tunez',
    iso3: 'TUN',
  },
  {
    name: 'Turkmenistán',
    iso3: 'TKM',
  },
  {
    name: 'Turquía',
    iso3: 'TUR',
  },
  {
    name: 'Tuvalu',
    iso3: 'TUV',
  },
  {
    name: 'Ucrania',
    iso3: 'UKR',
  },
  {
    name: 'Uganda',
    iso3: 'UGA',
  },
  {
    name: 'Uruguay',
    iso3: 'URY',
  },
  {
    name: 'Uzbekistán',
    iso3: 'UZB',
  },
  {
    name: 'Vanuatu',
    iso3: 'VUT',
  },
  {
    name: 'Venezuela',
    iso3: 'VEN',
  },
  {
    name: 'Vietnam',
    iso3: 'VNM',
  },
  {
    name: 'Wallis y Futuna',
    iso3: 'WLF',
  },
  {
    name: 'Yemen',
    iso3: 'YEM',
  },
  {
    name: 'Yibuti',
    iso3: 'DJI',
  },
  {
    name: 'Zambia',
    iso3: 'ZMB',
  },
  {
    name: 'Zimbabue',
    iso3: 'ZWE',
  },
];
